const QuestionHeatMap = () => {

}

export default QuestionHeatMap;